import axios from 'axios';

export const expect404 = (err: unknown) => {
  if (axios.isAxiosError(err) && err.response?.status === 404) {
    return null;
  }

  throw err;
};
